export function isAbortedRequest(error: Error) {
	return error && error.name == "AbortError";
}
